import { useRef } from "react";
import { useIsomorphicEffect } from "./auth-service-tools644.js";

function useLiveRef(value) {
  var ref = useRef(value);
  useIsomorphicEffect(function () {
    ref.current = value;
  });
  return ref;
}

export { useLiveRef };